import React from 'react';

import {
    FormControl,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    Typography,
    useTheme,
} from '@mui/material';

interface FieldProps {
    label: string;
    value: string;
    isRadioGroup?: boolean;
}

export const Field: React.FC<FieldProps> = ({ label, value, isRadioGroup }) => {
    const theme = useTheme();

    return (
        <Grid item lg={6} xs={12} display="flex" flexDirection="column" gap="24px">
            {isRadioGroup ? (
                <>
                    <Typography
                        sx={{ fontSize: '14px', fontWeight: 600 }}
                        color={theme.palette.dark.main}
                    >
                        {label}
                    </Typography>
                    <FormControl component="fieldset">
                        <RadioGroup
                            aria-labelledby="service-billed-radio-buttons"
                            name="service-billed-radio-group"
                            row
                            defaultValue={value?.length > 0 ? true : false}
                            onChange={() => {}}
                        >
                            <FormControlLabel
                                value={true}
                                control={<Radio disabled />}
                                label="Yes"
                                onClick={() => {}}
                            />
                            <FormControlLabel
                                value={false}
                                control={<Radio disabled />}
                                label="No"
                                onClick={() => {}}
                            />
                        </RadioGroup>
                    </FormControl>
                </>
            ) : (
                <>
                    <Typography
                        sx={{ fontSize: '14px', fontWeight: 600 }}
                        color={theme.palette.dark.main}
                    >
                        {label}
                    </Typography>
                    <Typography sx={{ fontSize: '20px', fontWeight: 400 }} color="#8E8E8D">
                        {value || '-'}
                    </Typography>
                </>
            )}
        </Grid>
    );
};
